import { Breadcrumbs } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { ImportConversionPanel } from "~/components/specifics/settings/imports/[importType]/ImportConversionPanel";
import { ImportFileUploadPanel } from "~/components/specifics/settings/imports/[importType]/ImportFileUploadPanel";
import { ImportLogTable } from "~/components/specifics/settings/imports/[importType]/ImportLogTable";
import { useImportLogs } from "~/hooks/admin/useImportLogs";
import {
	convertImportType,
	importTypeLabels,
	isImportType
} from "~/models/ImportLog";
import { PATH } from "~/pages/settings/imports";
import SettingStyles from "../../SettingStyle.module.scss";
import Styles from "./Page.module.scss";

type Props = {
	importType: string;
};

export const Page: React.FC<Props> = ({ importType }: Props) => {
	const { data: importLogByTypes, mutate: mutateLogs } =
		useImportLogs().useIndex();
	const handleMutate = React.useCallback(async () => {
		await mutateLogs();
	}, [mutateLogs]);

	if (!isImportType(importType) || importLogByTypes === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "過去データ取込" },
							{ label: importTypeLabels[importType] }
						]}
					/>
				</div>
				<h2 className={SettingStyles.SettingTitle}>
					{importTypeLabels[importType]}のデータ取込
				</h2>
				<div className={Styles.TopArea}>
					<div className={Styles.UploadPanelWrapper}>
						<h3 className={Styles.SubTitle}>ファイルアップロード</h3>
						<ImportFileUploadPanel
							handleMutate={handleMutate}
							importType={importType}
						/>
					</div>
					<ImportConversionPanel importType={importType} />
				</div>
				<div className={Styles.TablePanelWrapper}>
					<h3 className={Styles.SubTitle}>過去の取込履歴</h3>
					<ImportLogTable
						importLogs={importLogByTypes[convertImportType(importType)].logs}
					/>
				</div>
			</ClientSettingLayout>
		</DefaultV2>
	);
};
